module.exports = __webpack_public_path__ + "img/icb-opening-03.7dfcf09b.png";